import { useStaticQuery, graphql } from "gatsby";
import * as React from "react";
import Layout from "../components/layout";

const Index = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "/home", idType: URI) {
          homePage {
            heading
            subheading
            leftButton {
              target
              title
              url
            }
            rightButton {
              target
              title
              url
            }
            subheading
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.homePage || {};

  return (
    <Layout pageContext={pageContext}>
      <title>Home | AirMc</title>
      <div className="bg-black text-white text-center">
        <h1 className="container mx-auto  font-anton text-7xl uppercase pt-32">
          {data?.heading}
        </h1>
        <p className="container font-proxima text-4xl mt-4">
          {data?.subheading}
        </p>

        <div className="container mx-auto py-20 max-w-screen-lg	">
          <div className="flex flex-wrap sm:justify-center md:justify-between font-anton text-4xl text-black text-center uppercase">
            <div className="flex flex-col h-56 justify-between w-96 mx-auto">
              <div className="mx-auto">
                <svg width="88.234" height="100" viewBox="0 0 88.234 100">
                  <path
                    id="np_love-house_811808_FFFFFF"
                    d="M85.293,28.992V2.941A2.941,2.941,0,0,0,82.352,0h-8.82A2.941,2.941,0,0,0,70.59,2.941V13.722ZM14.707,94.117H7.34A1.463,1.463,0,0,0,5.883,95.6v2.914A1.476,1.476,0,0,0,7.34,100H92.66a1.463,1.463,0,0,0,1.457-1.484V95.6a1.478,1.478,0,0,0-1.457-1.484H85.293V44.687l2.613,2.043a1.74,1.74,0,0,0,2.223-.133l2.1-2.02a1.483,1.483,0,0,0,.051-2.086L52.117.9a2.935,2.935,0,0,0-4.234,0L7.723,42.492a1.469,1.469,0,0,0,.051,2.086l2.1,2.02a1.759,1.759,0,0,0,2.223.133l2.613-2.043Zm34.27-47.828a11.021,11.021,0,0,0-15.59-.012l-.344.344a11.028,11.028,0,0,0,.012,15.59L47.922,77.078a2.938,2.938,0,0,0,4.156,0L66.945,62.211a11.028,11.028,0,0,0,.012-15.59l-.344-.344a11.021,11.021,0,0,0-15.59.012L50,47.312ZM37.211,58.055a5.148,5.148,0,0,1-.008-7.273l.344-.344a5.133,5.133,0,0,1,7.27.012l3.105,3.1a2.938,2.938,0,0,0,4.156,0l3.105-3.1a5.133,5.133,0,0,1,7.27-.012l.344.344a5.148,5.148,0,0,1-.008,7.273L50,70.84Z"
                    transform="translate(-5.883 0.001)"
                    fill="#ED2525"
                    fillRule="evenodd"
                  />
                </svg>
              </div>
              <a
                href={data?.leftButton?.url}
                target={data?.leftButton?.target}
                className="bg-red py-5 w-11/12 mx-auto"
              >
                {data?.leftButton?.title}
              </a>
            </div>
            <div className="bg-tan md:w-1 md:h-52 my-auto"></div>
            <div className="flex flex-col h-56 justify-between w-96 mx-auto mt-12 md:mt-0">
              <div className="mx-auto">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="83.008"
                  height="83.008"
                  viewBox="0 0 83.008 83.008"
                >
                  <path
                    id="np_factory_888657_FFFFFF"
                    d="M68.555,68.555v-16.6l-33.2,16.6-2.765-49.8H21.52l-2.77,49.8v33.2h83.008v-49.8Zm-24.9,24.9h-16.6V82.391h16.6Zm24.9,0h-16.6V82.391h16.6Zm24.9,0h-16.6V82.391h16.6Z"
                    transform="translate(-18.75 -18.75)"
                    fill="#0f7fff"
                  />
                </svg>
              </div>
              <a
                href={data?.rightButton?.url}
                target={data?.rightButton?.target}
                className="bg-blue py-5 w-11/12 mx-auto"
              >
                {data?.rightButton?.title}
              </a>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Index;
